import React from "react";
import {Link} from "react-router-dom";
import mapImage from "../img/map.png";
import { Markup } from "interweave";

const Footer = ({ website }) => {
  return (
    <div className="container footer container-bg">
      <div className="row align-center">
        <div className="col-sm miniMap">
          <div className="row ">
            <Link className="nav-link" to="/contact">
              <img src={mapImage} className="card-img-top" alt="miniMap" />
            </Link>
          </div>
        </div>
        <div className="col-sm">
          <div className="row">
            <Markup content={website.footer} />
          </div>
        </div>
        <div className="col-sm right">
            <Link className="nav-link" to="/presentation">
                La boutique
            </Link>
            <Link className="nav-link" to="/marques">
                Les marques
            </Link>
            <Link className="nav-link" to="/contact">
                Contact
            </Link>
            <Link className="nav-link" to="/legal">
                Mentions légales
            </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
